import { render } from "./TeoLogin.vue?vue&type=template&id=0b8dad90&scoped=true"
import script from "./TeoLogin.vue?vue&type=script&lang=js"
export * from "./TeoLogin.vue?vue&type=script&lang=js"

import "./TeoLogin.vue?vue&type=style&index=0&id=0b8dad90&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b8dad90"]])

export default __exports__